import { initWebSession, endWebSession, getDefaultHeader } from '../../services/serviceAPIHelper';
import i18n from '../../services/i18n.js';
import moment from 'moment';
import { setCMSConfiguration } from '../../cms/cmsLib';

export function login(user) {
    // user = { 'username': '', password: ''}
    return fetch(process.env.REACT_APP_API_URL + 'login', {
        headers: getDefaultHeader(false),
        method: 'POST',
        body: JSON.stringify(user)
    })
        .then(async (response) => {
            return await setUserData(response);
        }).catch((e) => {
            throw e;
        });
}

/**
 * Funcion que a partir de un token inicia sesión del usuario correspondiente
 * https://xcaleconsulting.atlassian.net/browse/OLYB2B-353
 * La tarea se completa con la tarea https://xcaleconsulting.atlassian.net/browse/OLYB2B-512 que generará
 * las url de los usuarios.
 * @param {*} token
 */
export function loginToken(token) {
    //Test de conexion al login
    return fetch(process.env.REACT_APP_API_URL + 'loginToken/' + token, {
        headers: getDefaultHeader(false),
        method: 'GET'
    })
        .then(async (response) => {
            return await setUserData(response);
        });
}

/**
 * Funcion que reconecta al usuario con el refresh token
 */
export function reconnect() {
    //Test de conexion al login
    let refresh_token = localStorage.getItem('refresh_token');
    const user = JSON.parse(localStorage.getItem('user'));
    return fetch(process.env.REACT_APP_API_URL + 'login/reconnect', {
        headers: getDefaultHeader(false),
        method: 'POST',
        body: JSON.stringify({ 'refresh_token': refresh_token, 'username': user.user_name })
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        })
        .then((value) => {
            storeUserObject(value);
            initWebSession();
            return value;
        });
}
/**
 *
 * @param String con formato jwt donde decodificamos el user object
 */
export function storeUserObject(user) {
    window.localStorage.setItem('token', user.access_token);
    window.localStorage.setItem('refresh_token', user.refresh_token);
    setCMSConfiguration({ ...user.cmsConfiguration });
    delete user.cmsConfiguration;
    window.localStorage.setItem('user', JSON.stringify(user));
    window.localStorage.setItem('language_avail', JSON.stringify(user.languagesAvailables));
}

/**
 * this function clear all user related information and tokens and also redirect to main page.
 */
export async function logout() {
    //remuevo los items mas importantes porque a veces clear no funciona depende el browser.
    await window.localStorage.removeItem('token');
    await window.localStorage.removeItem('user');
    await window.localStorage.removeItem('redirectTo');
    await window.localStorage.removeItem('selectedTab');
    window.localStorage.clear();
    endWebSession();
    //window.location.replace('/');
}
/**
 * Esta funcion decodifica el token json y devuelve un Object
 */
export function parseJwt(token) {
    return JSON.parse(jwt(token));
}
/**
 * Esta funcion decodifica el token y devuelve un JSON string
 */
export function jwt(token) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    return window.atob(base64);
}
/**
 * Devuelve el idioma del usuario
 */
export function getUserLanguage() {
    let currentUser = getUserInformation();
    if (currentUser && currentUser.user_detail) {
        return currentUser.user_detail.language.toLowerCase();
    }
    return process.env.REACT_APP_DEFAULT_LANGUAGE;
}

/**
 * this function return the user object decoding it from json in local storage.
 */
export function getUserInformation() {
    let userjson = localStorage.getItem('user');
    if (userjson === 'null') {
        return null;
    }
    return JSON.parse(userjson);
}


async function setUserData(response) {
    if (response.ok) {
        let res = response.clone();
        const user = await res.json();
        storeUserObject(user);
        const language = user.user_detail.language.toLowerCase();
        i18n.changeLanguage(language, (err, t) => {
            if (err)
                return console.log('Error al cargar el idioma', err);
        });
        //OLYB2B-929 glob fix set moment user locale
        // moment.updateLocale(language, locales[language]);
        //moment.locale(language, locales[language]);
        initWebSession(true);
        return response.json();
    } else {
        throw response;
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/loginService.js